import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import Avatar from "@mui/material/Avatar"
import CloseIcon from "@mui/icons-material/Close"
import SettingsIcon from "@mui/icons-material/Settings"
import GroupsIcon from "@mui/icons-material/Groups"
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff"
import { MONO } from "../constants"

export function TabBtn({ label, active, onClick, color, onClose, dot, avatar, muted, onSettings, status }) {
  return (
    <Box onClick={onClick} sx={{ display: "flex", alignItems: "center", gap: 0.4,
      px: 1.25, py: 0.7, cursor: "pointer", flexShrink: 0,
      borderBottom: "2px solid " + (active ? color : "transparent"),
      color: active ? color : "rgba(var(--app-fg-rgb),0.32)",
      fontFamily: MONO, fontSize: "0.67rem", fontWeight: active ? 600 : 400,
      transition: "color 0.12s, border-color 0.12s",
      "&:hover": { color: active ? color : "rgba(var(--app-fg-rgb),0.62)" }, userSelect: "none" }}>
      {avatar !== undefined && (
        avatar
          ? <Avatar src={avatar} sx={{ width: 16, height: 16, flexShrink: 0 }} />
          : <Avatar sx={{ width: 16, height: 16, flexShrink: 0, bgcolor: "rgba(var(--app-fg-rgb),0.08)" }}>
              <GroupsIcon sx={{ fontSize: 10 }} />
            </Avatar>
      )}
      {dot !== undefined && (
        <Box sx={{ width: 5, height: 5, borderRadius: "50%",
          backgroundColor: dot ? "var(--app-success)" : "rgba(var(--app-fg-rgb),0.18)", flexShrink: 0 }} />
      )}
      <span style={{ maxWidth: 72, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
      {status && <span title={status} style={{ maxWidth: 54, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "0.52rem", opacity: 0.55 }}>· {status}</span>}
      {muted && <NotificationsOffIcon sx={{ fontSize: 10, opacity: 0.5, flexShrink: 0 }} />}
      {onSettings && active && (
        <IconButton size="small" onClick={(e) => { e.stopPropagation(); onSettings() }}
          sx={{ p: 0, color: "inherit", opacity: 0.55, ml: 0.2, "&:hover": { opacity: 1 } }}>
          <SettingsIcon sx={{ fontSize: 11 }} />
        </IconButton>
      )}
      {onClose && (
        <IconButton size="small" onClick={(e) => { e.stopPropagation(); onClose() }}
          sx={{ p: 0, color: "inherit", opacity: 0.45, ml: 0.2, "&:hover": { opacity: 1 } }}>
          <CloseIcon sx={{ fontSize: 9 }} />
        </IconButton>
      )}
    </Box>
  )
}

export default TabBtn
